var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 45,
    fill: "#224A91"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1534 43.843L43.7645 50.454M43.7645 50.454L50.3756 43.843M43.7645 50.454V35.2486C43.7645 32.95 43.7645 31.8008 42.8546 30.514C42.2501 29.6591 40.5095 28.6039 39.4719 28.4633C37.9102 28.2517 37.3172 28.5611 36.1311 29.1798C30.8454 31.9371 27.2368 37.4686 27.2368 43.843C27.2368 52.971 34.6365 60.3707 43.7645 60.3707C52.8925 60.3707 60.2922 52.971 60.2922 43.843C60.2922 37.7254 56.9685 32.3841 52.0284 29.5264",
    stroke: "white",
    strokeWidth: 3.55263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDownload);
export default __webpack_public_path__ + "static/media/circle-download.1a57a4706047beaced92aa4916fbe4c5.svg";
export { ForwardRef as ReactComponent };